// Dependencies
import React from "react";

// Material UI Components
import Typography from "@mui/material/Typography";

// Components
import VideoEmbed from "components/video/VideoEmbed/VideoEmbed.component";

// Helpers

// styles
import { useStyles } from "../VideoGallery/VideoGallery.styles";

const VideoCard = ({ medium }) => {
  const classes = useStyles();

  return (
    <div className={classes.videoCardContainer} data-component="VideoCard">
      <VideoEmbed medium={medium} />
      <Typography
        variant="h4"
        component="h3"
        className={classes.videoCardTitle}
        data-cy="video-gallery-title"
      >
        {medium.title}
      </Typography>
    </div>
  );
};

export default VideoCard;
